import { useBundleContext } from '@/src/packages/components/pages/Bundle/BundleContext';
import { ProductSizeSelector } from '@/src/packages/components/pages/Product/ProductControls/ProductOptions/ProductSizeSelector/ProductSizeSelector';
import {
  IFetchBundleSchema,
  IFetchProductVariantSchema,
} from '@bitmap/contracts';

export const BundleOption = ({
  option,
  productVariant,
}: {
  productVariant: IFetchBundleSchema['variants'][0];
  option: IFetchProductVariantSchema['product']['options'][0];
}) => {
  const { setSelectedOptions, selectedOptions } = useBundleContext();

  return (
    <ProductSizeSelector
      handleSelectOption={(option, value) => {
        const productIndex = selectedOptions.findIndex(
          (i) =>
            i.productId === productVariant.product.id &&
            i.optionId === option.id
        );

        if (productIndex >= 0) {
          const cloned = [...selectedOptions];

          cloned[productIndex] = {
            optionId: option.id,
            optionName: option.name,
            productId: productVariant.product.id,
            value: value.id,
          };

          setSelectedOptions(cloned);
        }
      }}
      skus={productVariant.skus}
      option={option}
      selectedOptions={selectedOptions}
    />
  );
};
